import { Trans, useTranslation } from 'next-i18next';
import { FC } from 'react';
import TextArea from 'src/common/components/TextArea';
import UniversalLink from 'src/common/components/UniversalLink';
import { PATHS, SUPPORT_URLS } from 'src/common/constants';
import { useTripCartContext } from 'src/trip-cart-deprecated/hooks/useTripCartContext';
import { FORM_MESSAGE } from 'src/inquiry/constants';
import { useTripCartOptionsContext } from 'src/trip-cart-deprecated/hooks/useTripCartOptionsContext';
import { TripCartFormState } from 'src/listing/types';
import { useFormState } from 'react-final-form';
import styles from './TripCartMessage.module.scss';

const TEXT_LIMIT = 250;
const TEXT_LIMIT_SHOW = 30; // how many characters before TEXT_LIMIT to show warning

const TripCartMessage: FC = () => {
  const [t] = useTranslation('common');
  const { listing } = useTripCartContext();
  const { options: { actions: { instabookVisible } } } = useTripCartOptionsContext();
  const { first_name: ownerName } = listing.user_details;
  const { values } = useFormState<TripCartFormState>();
  const characterCount = values.message?.length ?? 0;

  return (
    <TextArea
      name={FORM_MESSAGE}
      label={t('owner-message', { ownerName })}
      // owner-message--placeholder-inquiry, owner-message--placeholder-instabook
      placeholder={t(`owner-message--placeholder-${instabookVisible ? 'instabook' : 'inquiry'}`, { ownerName })}
      rows={2}
      maxLength={TEXT_LIMIT}
      rightSlot={
        characterCount >= TEXT_LIMIT - TEXT_LIMIT_SHOW
          ? (
            <span>
              {characterCount}
              /
              {TEXT_LIMIT}
            </span>
          ) : undefined
      }
      toolTipContent={(
        <Trans
          t={t}
          i18nKey="communications-warning--description"
          components={[
            <UniversalLink
              className={styles.tooltipLink}
              href={PATHS.TERMS}
              openInNewTab
            />,
            <UniversalLink
              className={styles.tooltipLink}
              href={SUPPORT_URLS.WHY_COMMUNICATE_AND_PAY_THROUGH_GETMYBOAT}
              openInNewTab
            />,
          ]}
        />
      )}
    />
  );
};

export default TripCartMessage;
